<template>
    <div class="main-content custom-scrollbar-all">
        <div class="page-content">
            <div class="login-container">
                <div class="login-main">
                    <div class="login-box text-left">
                        <h4 class="headerClass">BrikTok</h4>
                        <!-- <div class="d-flex justify-content-center mb-3">
                            <img src="{{siteimage}}" />
                        </div> -->
                        <form>
                            <div class="login-box-fields action row">
                                <div class="col-lg-12">
                                    <div class="alert alert-info" role="alert">
                                        <span class="d-block"><i class="feather-check mr-2"></i><strong>{{ $t('CRMSetting.LoanUploadDocumentRequiredDocument') }}:</strong> {{ requireDoc }} </span>
                                        <span class="d-block"><i class="feather-check mr-2"></i><strong>{{ $t('CRMSetting.LoanUploadDocumentUploadedDocument') }}:</strong> {{ recieveDocument }}</span>
                                        <span class="d-block"><i class="feather-check mr-2"></i><strong>{{ $t('CRMSetting.LoanUploadDocumentPendingDocument') }}:</strong> {{ pendingDoc }}</span>
                                    </div>
                                    <hr class="mb-3" />
                                </div>
                                <div class="col-lg-12">
                                    <div class="alert alert-info" role="alert">
                                        <b>{{ $t('CRMSetting.LoanUploadDocumentRequiredDocument') }}:</b>
                                        <span class="d-block" v-for="item of lstfiletype" :key="item.id">
                                            <span v-if="checkMandatory(item.documentType)"> {{ item.documentType }} </span>
                                        </span>
                                    </div>
                                    <hr class="mb-3" />
                                </div>
                                <div class="col-lg-12">
                                    <label>{{ $t('CRMSetting.LoanUploadDcoumentChooseDocument') }}:<span class="text-danger">*</span></label>
                                    <div class="form-group">
                                        <div class="input-group">
                                            <div class="input-group-prepend" v-if="imageLink != ''">
                                                <div id="myModal" style=" background: none !important;" class="modal fade"
                                                    tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
                                                    aria-hidden="true">
                                                    <div class="modal-dialog"
                                                        style="height:450px!important;width:450px!important; ">
                                                        <div class="">
                                                            <button type="button" class="close"
                                                                style="color: #fff!important; "
                                                                data-dismiss="modal">&times;</button>
                                                        </div>
                                                        <div class="modal-content">
                                                            <div class="text-center">
                                                                <img src={{imageLink}} alt="img"
                                                                    style="height:450px!important;width:450px!important; "
                                                                    class="img-responsive">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="custom-file w-50 m-fileup">
                                                <input class="custom-file-input" type="file" name='file' id="fileId"
                                                    :accept="fileExtension" @change="setFile($event)" lang="es">
                                                <label class="custom-file-label">{{ fileName }}</label>

                                            </div>
                                            <!-- <small v-if="!isValid" style="color:red;" class="w-100 mt-1">Document is
                                                required</small> -->
                                            <span v-if="v$.profilePic.$invalid && v$.profilePic.$dirty" style="color:red;"
                                                class="w-100 mt-1">{{ $t('CRMSetting.DocMappingDocumentRequired') }}</span>
                                            <span><i class="text-secondary">{{ $t('CRMSetting.LoanUploadDocumentFormat') }}</i> </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <label>{{ $t('CRMSetting.LoanUploadDcoumentDocumentType') }}:<span class="text-danger">*</span></label>
                                    <div class="form-group">
                                        <Dropdown :emptyFilterMessage="$t('CRMSetting.DropdownNoResultFound')" :emptyMessage="$t('CRMSetting.DropdownNoAvailableOptions')" v-model="UploadimageForm.filetype" :options="lstfiletype" showClear
                                            optionLabel="documentType" optionValue="id" style="width: 100%"
                                            :placeholder="$t('CRMSetting.SelectFiletype')" class="w-full md:w-14rem"
                                            @change="fileNameDDL($event)" :class="{
                                                'is-invalid':
                                                    v$.filetype.$invalid && v$.filetype.$dirty,
                                            }" />

                                        <span v-if="v$.filetype.$invalid && v$.filetype.$dirty" style="color:red;">
                                            {{ $t('CRMSetting.SelectLabel') }} {{ $t('CRMSetting.LoanUploadDcoumentDocumentType') }}</span>
                                    </div>
                                </div>

                                <div class="col-lg-12 text-center">
                                    <a href="javascript:void(0);" @click="SaveImage()" class="btn btn-success">{{ $t('ManageAsset.UploadFiles') }}</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <Loading v-model:active="isLoading">
        </Loading>
    </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, computed } from "vue";
import { required, maxValue, minValue, helpers, decimal } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Dropdown from "primevue/dropdown";
import SimpleDialog from "@/views/shared/SimpleDialog.vue";
import { createConfirmDialog } from "vuejs-confirm-dialog";
import CommonService from "@/service/crmservice/commonService";
import LoanApplicationService from "@/service/crmservice/loanapplicationservice";
import { useRouter, useRoute } from "vue-router";
import { createToaster } from "@meforma/vue-toaster";
import InputMask from "primevue/inputmask";
import { email } from "@vuelidate/validators";
import CommonUses from "@/views/shared/common/commonuses";

//=========================================================== variables ===============================================//
const commonService = ref(new CommonService());
const loanApplicationService = ref(new LoanApplicationService());
const imageLink = ref(null);
const totalDocument = ref(null);
const loading = ref(false);
const recieveDocument = ref(null);
const requireDoc = ref(null);
const fileName = ref('Choose Document');
const lstfiletype = ref(null);
const usertype = ref(null);
const fileImageName = ref(null);
const fileuplist = ref(null);
const loanId = ref(null);
const fileNameddlvalue = ref(null);
const isLoading = ref(false);
const isValid = ref(true);
const accid = ref(null);
const siteURL = ref(null);
const url = ref(null);
const urldata = ref(null);
const siteimage = ref(null);
const sitetitle = ref(null);
const pendingDoc = ref(null);
const companyid = ref(null);
const fileTypesGroup = ref(null);
const fileSize = ref(5);
const fileExtension = ref("");
const fileInput = ref(null);
const fileuploadddl = ref(null);
const loadSave = ref(false);
const linkfrom = ref(null);
const route = useRoute();
const userId = ref(null);
const commonUses = ref(CommonUses);
const toaster = createToaster({ position: "top-right" });
const UploadimageForm = ref({
    profilePic: null,
    file: null,
    filename: null,
    filetype: null,
    documentTitle: null,
    description: null
});

const UploadimageFormRule = ref({
    profilePic: { required },
    filetype: { required }
})



const UploadimageFormRules = computed(() => UploadimageFormRule.value);
const v$ = useVuelidate(UploadimageFormRules, UploadimageForm.value);

//=========================================================== funcations ===============================================//

const checkMandatory = (item) => {
    if (item.indexOf("*") !== -1) {
        return true;
    }
    return false;
}


const setTitle = (newTitle) => {
    console.log("newTitle", newTitle);
    // this.titleService.setTitle(newTitle);
}

const decryptid = (id) => {
    return customHttpParamEncoder.value.decodeValue(id);
}

const getConfigurationTypeFileExtensions = () => {
    commonService.value.getConfigurationTypeFileExtensions('Loan Docs', companyid.value).then((result) => {
        if (result.data && result.data.FileTypesGroup != '') {
            fileSize.value = result.data.FileSize;
            fileTypesGroup.value = JSON.parse(result.data.FileTypesGroup);
            fileTypesGroup.value = fileTypesGroup.value.filter(x => x.Name == 'Image' || x.Name == 'Document');

            fileTypesGroup.value.forEach((obj, index) => {
                if (obj.FileTypes) {
                    let extension = obj.FileTypes.map(x => x.Name);
                    fileExtension.value += (index > 0 && fileExtension.value != "") ? ", " : "";
                    fileExtension.value += extension.join(", ");
                }
            });
        }
    });
}




const getDocumentForReceiveAndPending = () => {
    loanApplicationService.value
        .getDocumentForReceiveAndPendingforcustomer(userId.value, companyid.value, loanId.value, "EXTERNAL_LINK")
        .then((result) => {
            totalDocument.value = result.data.TotalDocs;
            recieveDocument.value = result.data.ReceivedDocs;
            pendingDoc.value = result.data.pendingDocs;
            requireDoc.value = result.data.requireDoc;
        });
}



const fileNameDDL = (e) => {
    if (e) {
        fileNameddlvalue.value = lstfiletype.value.filter(t => t.id == e.value)[0].documentType;
        if (fileNameddlvalue.value.includes("*")) {
            fileNameddlvalue.value = fileNameddlvalue.value.slice(0, -1);
            fileNameddlvalue.value = fileNameddlvalue.value.replace(/\s/g, "");
        }
    }
}


const GetLoanapplicationDocumentType = (id) => {
    loanApplicationService.value
        .GetLoanapplicationDocumentTypeforcust(userId.value, companyid.value, id)
        .then((result) => {
            lstfiletype.value = result.data
                .filter(function (itm) { return (itm.documentType != "Install Agreement" && itm.documentType != "Install Agreement*") });
        })
}


const SaveImage = () => {
    v$.value.$validate();
    if (v$.value.$error) {
        return false;
    } else {
        isLoading.value = true
        const companySetupModel = prepareFormDataForDocument();
        loanApplicationService.value.customeruploadfilePDF(companySetupModel).then((result) => {
            setTimeout(() => {
                if (result.data.statusCode == 200) {
                    toaster.success('Document has been uploaded successfully');
                    fileName.value = '';
                    UploadimageForm.value.filetype = null;
                    UploadimageForm.value.profilePic = null;
                    UploadimageFormRule.value.filetype = null;
                    UploadimageFormRule.value.profilePic = null;
                    getDocumentForReceiveAndPending();
                    isLoading.value = false;
                }
                else {
                    isLoading.value = false;
                    toaster.error(result.data.responseMessage);
                }
            }, 3000);
        }, error => {
            isLoading.value = false;
        });
    }
}


const prepareFormDataForDocument = () => {
    const input = new FormData();
    input.append('companyName', '');
    input.append('moduleid', '1800');
    input.append('submoduleid', '1810');
    input.append('refid', loanId.value);
    input.append('documentTitle', fileNameddlvalue.value);
    input.append('description', UploadimageForm.value.description == null ? '' : UploadimageForm.value.description);
    input.append('accountid', accid.value);
    input.append('filetype', UploadimageForm.value.filetype);
    input.append('fileExtension', fileExtension.value);
    input.append('linkfrom', linkfrom.value);
    input.append('UserId', userId.value);
    input.append('companyId', companyid.value);
    if (UploadimageForm.value.profilePic) {
        input.append('file', UploadimageForm.value.profilePic);
    }
    return input;
}

const setFile = ($event) => {
    if (
        $event.target.files[0] != null &&
        $event.target.files[0] != undefined &&
        $event.target.files[0] != ""
    ) {
        let checkExtension = commonUses.value.uploadLoanImageFileValidator($event);
        if (!checkExtension) {
            toaster.error(`Selected file format is not allowed.`);
            isLoading.value = false;
            document.querySelector('#fileId').value = ''
        }

        let checkSize = commonUses.value.validUploadDocumentSize($event.target.files[0].size, 5);
        if (!checkSize) {
            toaster.error(`Please upload file(s) of max. size 5MB.`);
            isLoading.value = false;
            console.log("selector", document.querySelector('#fileId'))
            document.querySelector('#fileId').value = ''
        }

        if (checkExtension && checkSize) {
            fileName.value = $event.target.files[0].name;
            UploadimageForm.value.profilePic = $event.target.files[0];
            isLoading.value = false;
        }
    } else {
        $event.value = '';
        isLoading.value = false;
    }
}



//=========================================================== onMounted ===============================================//
onMounted(() => {


    setTimeout(() => {
        if (route.params) {
            const companyIds = route.params.companyId;
            const id = route.params.id;
            //const encryptid = route.params.encryptid;
            const userIds = route.params.userId;
            const aid = route.params.accid;

            console.log("route.params", route)

            if (companyIds) {
                companyid.value = companyIds;
                getConfigurationTypeFileExtensions();
            }

            if (userIds) {
                userId.value = userIds;
            }

            if (aid) {
                accid.value = aid
            }


            if (id) {
                loanId.value = id;
                GetLoanapplicationDocumentType(loanId.value);
            }

            // if (encryptid) {
            //     loanapplicationservice.value.GetDecryptid(encryptid).then((result) => {

            //         if (result.data) {
            //             linkfrom.value = 'Mobile'
            //             loanId.value = result.data;
            //             GetLoanapplicationDocumentType(result.data);
            //             getDocumentForReceiveAndPending();
            //         }
            //     });
            // }

            getDocumentForReceiveAndPending();
            url.value = window.location.href;
            url.value = url.value.slice(9, 19);

            // userService.value.GetSiteURlwithaccount(accid.value).then((result) => {
            //     this.urldata = JSON.parse(result.data);
            //     if (result.data != null) {

            //         siteimage.value = urldata.value[0].CompanyLogo;
            //         sitetitle.value = urldata.value[0].SiteTitle;
            //         setTitle(sitetitle);
            //     }
            //     else {
            //         sitetitle.value = 'BrikTok'
            //         setTitle(sitetitle.value);
            //         siteimage.value = 'assets/default-theme/imagesNew/login-logo-solgen.png';
            //     }
            // })

            //    if (this.router.url.indexOf('app.loanhomi') > 0) {
            //     this.siteURL = "loanhomi";
            //   }
            //   else if (this.router.url.indexOf('app.solgenone') > 0) {
            //     this.siteURL = "solgenone";
            //   }
            //   else if (this.router.url.indexOf('solgen.zorbis') > 0) {
            //     this.siteURL = "solgenone";
            //   }
        }
    }, 3000);
})
</script>

<style>
.main-content {
    background: #b49859;
    border-color: #b49859;
    color: #ffffff;
    margin: 0;
    min-height: 300px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
}

.main-content {
    background: #b49859;
    border-color: #b49859;
    color: #ffffff;
    margin-top: 0;
    overflow: visible;
    padding: 0;
    position: relative;
    height: auto;
    max-width: 430px;
    width: 100%;
}

.login-main {
    min-height: 100vh;
    align-content: center;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 20px 0;
    width: 100%
}

.login-box {
    width: 100%;
    background-color: #fff;
    padding: 30px;
    text-align: center;
    border-radius: 0 0 4px 4px;
}

.text-left {
    text-align: left !important;
}

.mb-3,
.my-3 {
    margin-bottom: 1rem !important;
}

.justify-content-center {
    justify-content: center !important;
}

.d-flex {
    display: flex !important;
}

.page-content {
    background: #b49859;
    border-color: #b49859;
    color: #ffffff;
    margin-top: 0;
    overflow: visible;
    padding: 0;
    position: relative;
    height: auto;
    max-width: 430px;
}

.input-group>.custom-file {
    display: flex;
    align-items: center;
}

.input-group>.custom-file,
.input-group>.custom-select,
.input-group>.form-control {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0;
}

.input-group>.custom-file {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    margin-bottom: 0;
}

.custom-file-input {
    position: relative;
    z-index: 2;
    width: 100%;
    height: calc(2.25rem + 2px);
    margin: 0;
    opacity: 0;
    overflow: hidden;
}

input {
    color: #636e7b;
    font-family: Roboto, sans-serif !important;
    border: 1px solid #dfdfdf;
}

.modal.fade .modal-content {
    height: 100%;
    padding: 0;
    background: #fff;
    border: none;
    border-radius: 5px;
    overflow: hidden;
}

.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: 0.3rem;
    outline: 0;
}

.text-center {
    text-align: center !important;
}

.login-container .login-main img {
    max-width: 235px;
}

img {
    vertical-align: middle;
    border-style: none;
}

button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
}

.close {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

.modal-dialog {
    display: inline-block;
    text-align: left;
    vertical-align: middle;
    min-width: 800px;
}

.modal.fade .modal-dialog {
    transition: transform .3s ease-out;
    transform: translate(0, -25%);
}

.input-group-append,
.input-group-prepend {
    display: flex;
}

.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
}

.headerClass {
    color: black;
    text-align: center;
    margin-bottom: 20px;
}

.custom-file-label {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
    height: calc(2.25rem + 2px);
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    background-color: #fff;
    border-radius: 0.25rem;
}

.custom-file-label::after {
    color: #fff;
    background-color: #b49859;
    border-left: 1px solid #ccc;
}

.custom-file-label::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: calc(calc(2.25rem + 2px) - 1px * 2);
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    content: "Browse";
    border-radius: 0 0.25rem 0.25rem 0;
}

label {
    display: inline-block;
    margin-bottom: 5px;
}

input,
select,
textarea {
    color: #636e7b !important;
    font-family: Roboto, sans-serif !important;
    border: 1px solid #dfdfdf !important;
}

.custom-file-label {
    font-weight: 400 !important;
    color: #495057 !important;
    border: 1px solid #c1c1c1 !important;
}

.main-content .page-content .login-container .login-main .login-box .btn.btn-success {
    width: 100%;
    margin-top: 20px;
    font-size: 20px;
    border-radius: 3px;
    font-weight: 600;
}

.login-box .btn-success {
    background-color: #b49859 !important;
    border-color: #b49859 !important;
}
</style>
